import { setAuthenticator } from '@ms/yammer-web-authenticators';
import type MsalPopupAuthenticator from '@ms/yammer-web-authenticators/dist/embed/MsalPopupAuthenticator';
import { getNetworkContext } from '@ms/yammer-web-support/dist/location';

import config from '../config';

import { reportAuthError } from './reportAuthError';

const getAuthenticator = async (): Promise<MsalPopupAuthenticator> => {
  const networkContext = getNetworkContext(window.location.pathname);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (config as any).adal = config.msal;
  const tenant = networkContext?.networkType === 'Canonical' ? networkContext.permalink : config.msal.tenant;

  const { default: MsalPopupAuthenticator } = await import(
    /* webpackChunkName: "4-auth-msal" */ '@ms/yammer-web-authenticators/dist/embed/MsalPopupAuthenticator'
  );

  return new MsalPopupAuthenticator({ ...config.msal, tenant, onError: reportAuthError });
};

export type SetupAuthenticator = () => ReturnType<typeof getAuthenticator>;
export const setupAuthenticator: SetupAuthenticator = async () => {
  const authenticator = await getAuthenticator();
  setAuthenticator(authenticator);

  return authenticator;
};
